import { useTheme } from '@mui/material';
import React from 'react';
import { IDnsProvider } from 'types/api';

interface IDnsProviderLogoProps {
	dnsProvider: IDnsProvider;
	width?: number;
	height?: number;
}

const defaultSize = 32;

const DnsProviderLogo: React.FC<IDnsProviderLogoProps> = ({
	dnsProvider,
	width = defaultSize,
	height = defaultSize
}) => {
	const {
		palette: { mode }
	} = useTheme();

	const icon =
		mode === 'dark' ? dnsProvider.logos?.dark : dnsProvider.logos?.light;

	if (!icon) {
		return null;
	}

	return (
		<img
			src={icon}
			alt={`${dnsProvider.name} logo`}
			width={width}
			height={height}
		/>
	);
};

export default DnsProviderLogo;
